const bindExportColumns = (root) => {
  if (root.dataset.bound === "true") return
  root.dataset.bound = "true"

  const checkboxes = () => [...root.querySelectorAll("[data-export-column]")]

  root.querySelector("[data-export-columns-all]")?.addEventListener("click", (event) => {
    event.preventDefault()
    checkboxes().forEach((input) => {
      input.checked = true
    })
  })

  root.querySelector("[data-export-columns-none]")?.addEventListener("click", (event) => {
    event.preventDefault()
    checkboxes().forEach((input) => {
      input.checked = false
    })
  })
}

const selectedColumnsIn = (scope) =>
  [...scope.querySelectorAll("[data-export-column]:checked")]

const ensureColumnsSelected = (scope) => {
  if (selectedColumnsIn(scope).length > 0) return true
  window.alert("Sélectionnez au moins une colonne à exporter.")
  return false
}

const bindExportForms = () => {
  document.querySelectorAll("form[data-participants-export-form]").forEach((form) => {
    if (form.dataset.exportFormBound === "true") return
    form.dataset.exportFormBound = "true"

    form.addEventListener("submit", (event) => {
      if (!ensureColumnsSelected(form)) event.preventDefault()
    })
  })

  document.querySelectorAll("[data-participants-export-submit]").forEach((button) => {
    if (button.dataset.exportSubmitBound === "true") return
    button.dataset.exportSubmitBound = "true"

    button.addEventListener("click", (event) => {
      const scope =
        button.closest(".backoffice-modal") ||
        button.closest("form") ||
        document
      if (!ensureColumnsSelected(scope)) event.preventDefault()
    })
  })
}

const initBackofficeParticipantsExport = () => {
  document.querySelectorAll("[data-export-columns]").forEach(bindExportColumns)
  bindExportForms()
}

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("[data-export-columns]").forEach((root) => {
    root.dataset.bound = "false"
  })
  document.querySelectorAll("form[data-participants-export-form]").forEach((form) => {
    form.dataset.exportFormBound = "false"
  })
  document.querySelectorAll("[data-participants-export-submit]").forEach((button) => {
    button.dataset.exportSubmitBound = "false"
  })
})

export { initBackofficeParticipantsExport }
